function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoaderstars = function SvgLoaderstars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 200,
    height: 200,
    display: "block",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      transformOrigin: "50% 50%0",
      transform: "rotate(0deg) scale(1)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB9400",
    stroke: "#FB9400",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    d: "M37.8 84.8C33.6 75.2 26.6 68.1 17 63.6c9.8-3.8 16.7-10.6 20.8-20.4C42 52.9 48.9 59.9 58.6 64 48.9 68.2 42 75.1 37.8 84.8z",
    style: {
      transformBox: "view-box",
      transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)",
      animation: "1s linear -.625s infinite forwards stars",
      transformOrigin: "50px 50px 0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9400",
    stroke: "#FB9400",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    d: "M67.9 47.7c-2.7-6.2-7.1-10.7-13.3-13.5 6.3-2.4 10.6-6.8 13.3-13 2.7 6.2 7.1 10.6 13.3 13.3-6.2 2.6-10.6 7.1-13.3 13.2z",
    style: {
      transformBox: "view-box",
      transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)",
      animation: "1s linear -.75s infinite forwards stars",
      transformOrigin: "50px 50px 0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9400",
    stroke: "#FB9400",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    d: "M28.4 38c-2.3-5.3-6.2-9.2-11.4-11.6 5.4-2.1 9.2-5.8 11.4-11.2q3.45 7.95 11.4 11.4-7.95 3.45-11.4 11.4z",
    style: {
      transformBox: "view-box",
      transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)",
      animation: "1s linear -.875s infinite forwards stars",
      transformOrigin: "50px 50px 0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB9400",
    stroke: "#FB9400",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    d: "M73.8 81.6c-1.9-4.3-5-7.4-9.2-9.4 4.3-1.7 7.4-4.7 9.2-9 1.8 4.3 4.9 7.4 9.2 9.2-4.3 1.9-7.4 4.9-9.2 9.2z",
    style: {
      transformBox: "view-box",
      transform: "matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)",
      animation: "1s linear -1s infinite forwards stars",
      transformOrigin: "50px 50px 0"
    }
  })));
};
export { SvgLoaderstars as ReactComponent };
export default "data:image/svg+xml;base64,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";